import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import axios from "../config/axiosWithLocation";

const initialState = {
  categories: null,
  selectedCategory: null,
  error: null,
  isLoading: false,
};

export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async (payload, thunkAPI) => {
    const response = await axios
      .get("/restaurant/categories")
      .then((res) => {
        return res.data.categories;
      })
      .catch((err) => {
        return thunkAPI.rejectWithValue(
          "Something went wrong! Please try again later"
        );
      });
    return response;
  }
);

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategories.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCategories.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      if (action.payload.length === 0) {
        state.categories = [];
      } else {
        state.categories = action.payload;
      }
    });
    builder.addCase(fetchCategories.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { setCategories, setSelectedCategory } = categorySlice.actions;

export default categorySlice.reducer;
